import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/ic-selector.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "ui-input__label"
}
const _hoisted_3 = { class: "ui-selector__container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "ui-selector__icon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "ui-selector__current" }
const _hoisted_6 = {
  key: 1,
  class: "ui-selector__menu"
}
const _hoisted_7 = {
  key: 0,
  class: "ui-selector__search"
}
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-selector", {'ui-selector--disabled': _ctx.$attrs.disabled}]),
    ref: "refRoot",
    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (!_ctx.$attrs.disabled && (_ctx.showOptions = !_ctx.showOptions)), ["stop"]))
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.modelValue?.name || _ctx.placeholder), 1)
      ])
    ]),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.useSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_UiInput, {
                  ref: "input",
                  modelValue: _ctx.searchValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                  search: "",
                  autofocus: "",
                  flat: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "ui-selector__menu-item",
              onClick: ($event: any) => (_ctx.$emit('update:modelValue', option))
            }, _toDisplayString(option.name), 9, _hoisted_8))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}